import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container mt-6" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "column" }, [
  /*#__PURE__*/_createVNode("h1", { class: "title" }, "Teams")
], -1)
const _hoisted_5 = { class: "column is-narrow" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Add team ")
const _hoisted_7 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "icon-text" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-spin fa-sync-alt" })
  ]),
  /*#__PURE__*/_createVNode("span", null, "Loading...")
], -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "table is-bordered is-fullwidth is-narrow mt-4"
}
const _hoisted_12 = { class: "is-narrow p-0" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/teams/create",
            class: "button is-dark"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_7,
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _hoisted_9
          ]))
        : (!_ctx.teams?.length)
          ? (_openBlock(), _createBlock("div", _hoisted_10, "No teams yet"))
          : (_openBlock(), _createBlock("table", _hoisted_11, [
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.teams, (team) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: team.id
                  }, [
                    _createVNode("td", {
                      onClick: ($event: any) => (_ctx.$router.push(`/teams/${team.id}`)),
                      class: "is-clickable is-vcentered"
                    }, _toDisplayString(team.name), 9, ["onClick"]),
                    _createVNode("td", _hoisted_12, [
                      _createVNode("button", {
                        type: "button",
                        class: "button is-danger is-inverted",
                        onClickCapture: _withModifiers(($event: any) => (_ctx.removeTeam(team.id)), ["prevent"])
                      }, [
                        _hoisted_13
                      ], 40, ["onClickCapture"])
                    ])
                  ]))
                }), 128))
              ])
            ]))
    ])
  ]))
}